import React from 'react';
import './Banner.css';

const Banner = () => {
  const websiteUrl = 'https://www.atlantamagazine.com/top-doctors/rheumatology/'; 

  return (
    <a href={websiteUrl} className="banner-link">
      <div className="banner">
        Awarded top doctor in Rheumatology
      </div>
    </a>
  );
};

export default Banner;
